export default __webpack_public_path__ + "static/media/500_it.2cda2c1b.xls";